import React from 'react';
import { createRoot } from 'react-dom/client';
import './Components/LoginStyle.css';
import LoginEntry from "./Components/LoginEntry.js";
import ErrorBoundary from './Components/LoginErrorBoundary';

export const initlogin = function () {
    try {
        console.log("Login init");
        let divID = window.ScreenType != "OKPROCEED" ? "LoginErrorDiv" : 'LoginDiv';
        let iDiv = document.createElement('div');
        iDiv.id = divID;
        iDiv.style.opacity = "95%";
        document.getElementsByTagName('form')[0].appendChild(iDiv);
        let showComp = getComponent(screen);
        createRoot(document.getElementById(divID)).render(showComp);
    }
    catch (e) {
        console.error("Login Component could not be loaded"+e);
    }
}
function getComponent() {
    let InitialData = (window._InitialData || {});
    return <ErrorBoundary><LoginEntry ViewData={InitialData.ViewData} screenType={window.ScreenType} Status={InitialData.Status} Messages={InitialData.Messages} /></ErrorBoundary>;
   
}
var theFrame = document.createElement('div');
theFrame.id = 'loginBanner';
theFrame.className = 'bannerImg';
document.getElementsByTagName('form')[0].appendChild(theFrame);


